<ul class="timeline m-0" [class.timeline--bullet-fill]="bulletStyle === 'fill'">
  <li
    class="timeline__item"
    [class.timeline--lg-bullet]="item.bulletIconSize === 'lg'"
    *ngFor="let item of displayedList; let i = index; let last = last; trackBy: trackByEntry"
    [ngClass]="{
      'timeline__item--danger': item.danger,
      'timeline__item--completed': item.state === 'completed',
      'timeline__item--current': item.state === 'current',
      'timeline__item--pending': item.state === 'pending',
      'timeline__item--skipped': item.state === 'skipped'
    }"
  >
    <div class="timeline__bullet">
      <app-icon
        [name]="item.bulletIcon"
        [type]="item.bulletIconType"
        [size]="item.bulletIconSize"
        [ngStyle]="item.bulletIconColor ? { color: item.bulletIconColor } : {}"
        *ngIf="item?.bulletIcon"
      ></app-icon>
      <span
        *ngIf="!item?.bulletIcon"
        class="timeline__bullet-shape"
        [ngStyle]="item.bulletColor ? { 'border-color': item.bulletColor, 'background-color': item.bulletColor } : {}"
      ></span>
    </div>

    <div class="timeline__item-content">
      <ng-container *ngIf="itemTemplate; else defaultItemContent">
        <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: item.item, index: i }"></ng-container>
      </ng-container>

      <ng-template #defaultItemContent>
      <div class="row align-flex-start gx-sm">
        <div class="col">
          <div class="row gx-xs align-flex-start">
            <div class="col-auto flex" *ngIf="item.contentIcon">
              <app-icon
                [name]="item.contentIcon"
                [type]="item.contentIconType"
                [size]="item.contentIconSize"
                class="timeline__item-icon"
                [ngStyle]="item.contentIconColor ? { color: item.contentIconColor } : {}"
              ></app-icon>
            </div>
            <div class="col-auto">
              <div
                class="timeline__item-label"
                [class.timeline__item-label-bold]="labelBold || item.labelBold"
                [ngStyle]="item.labelColor ? { color: item.labelColor } : {}"
              >
                <ng-container *ngIf="translationPrefix">{{ translationPrefix + '.' + item.label | translate }}</ng-container>
                <ng-container *ngIf="!translationPrefix">{{ item.label }}</ng-container>
              </div>

              <div
                class="timeline__item-value"
                *ngIf="item.value"
                [ngStyle]="item.valueColor ? { color: item.valueColor } : {}"
              >
                {{ valuePrefix }} {{ item.value }}
              </div>

              <div
                class="timeline__item-description"
                *ngFor="let line of item.descriptionLines"
                [ngStyle]="line.color ? { color: line.color } : {}"
              >
                {{ line.text }}
              </div>
            </div>

          </div>
        </div>
        <div class="col-auto flex" *ngIf="item.date">
          <time class="timeline__item-date">{{ item?.date | date : 'd MMM yyyy, h:mm a' }}</time>
        </div>

        <div
          class="col-auto"
          *ngIf="(actions && actions.length && !handleEmptyRequestState) || (actions && actions.length && item.item.requestBody && handleEmptyRequestState)"
        >
          <div class="row no-gutters">
            <div class="col" *ngFor="let action of actions">
              <button
                type="button"
                class="btn--xsmall btn--text-primary w-auto text-nowrap"
                mat-button
                color="primary"
                (click)="actionClicked.emit({ item: item.item, action: action.id })"
              >
                {{ action.label }}
              </button>
            </div>
          </div>
        </div>

        <div class="col-auto" *ngIf="emptyRequestActions && emptyRequestActions.length && handleEmptyRequestState && !item.item.requestBody">
          <div class="row no-gutters">
            <div class="col" *ngFor="let action of emptyRequestActions">
              <button type="button" class="btn--xsmall text-warn w-auto text-nowrap" mat-button (click)="actionClicked.emit({ item: item.item, action: action.id })">
                {{ action.label }}
              </button>
            </div>
          </div>
        </div>

      </div>
      </ng-template>
      
      <ng-container
        *ngIf="itemContentTemplate"
        [ngTemplateOutlet]="itemContentTemplate"
        [ngTemplateOutletContext]="{ $implicit: item.item, index: index, last: last }"
      ></ng-container>
    </div>
  </li>
</ul>
